<template>
  <div>
    <div class="content">
      <div class="col col-logos" v-html="content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Col1',

  data () {
    return {
    }
  },

  props: {
    content: {
      type: String,
      required: false,
      default: 'Content goes here'
    }
  }
}
</script>

<style>
.content .col-logos {
  margin-top: 50px;
  padding-left: 20px;
  padding-right: 20px;
}

.logos {
   width: 150px;
   height: auto;
   margin: 10px;
   display: inline-block;
   vertical-align: middle;
   text-align: center;
}
</style>
